<template>
    <div class="index-total">
        <div class="tm0">
            <span class="tm0_1">商品金额</span>
            <span>￥{{trial.totalGoodPrice||'0.00'}}</span>
        </div>
        <div class="tm0">
            <span class="tm0_1">店铺优惠</span>
            <span class="tm0_2">-￥{{trial.branchDiscountPrice||'0.00'}}</span>
        </div>
        <div class="tm1">
            <span class="tm1_1">应付商品款（不含运费，未抹零）：</span>
            <span class="tm1_2">￥{{trial.erasePreTotalPrice||'0.00'}}</span>
        </div>
        <div class="tm1">
            <span class="tm1_1">应付商品款（不含运费<span v-show="trial.eraseOddType">，</span><i>{{trial.eraseOddType}}</i>）：</span>
            <span class="tm1_2">￥{{trial.resulSettlePrice||'0.00'}}</span>
        </div>
        <div class="tm2">试算编码：{{trial.trialCode}}</div>
    </div>
</template>
<script>
export default {
    props: {
        trial: {
            default: function() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style lang="less" scoped>
.index-total {
    margin-top: 10px;
    padding: 20px 40px 25px;
    background-color: #fff;
    border-radius: 20px;
    .tm0 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        font-size: 24px;
        height: 63px;
        line-height: 63px;

        .tm0_1 {
            display: inline-block;
            width: 180px;
            text-align: center;
            flex-shrink: 0;
            background-color: #f2f2f2;
        }
        .tm0_2 {
            color: #ED3939;
        }
    }
    .tm1, .tm2 {
        height: 63px;
        line-height: 63px;
        font-size: 24px;
        text-align: right;
        .tm1_1 {
            color: #999;

            i {
                font-style: normal;
                color: #ED3939;
            }
        }
        .tm1_2 {
            color: #ED3939;
            font-weight: 500;
        }
    }
    .tm2 {
        text-align: center;
        color: #ccc;
    }
}
</style>